import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseResponse } from "../models/base.response";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class ObjectivesService {
    constructor(private http: HttpClient) {}

    findAll(userId: string) {
        let params = new HttpParams().set('userId', userId);
        return this.http.get<BaseResponse<any>>(`${environment.apiUrl}/objectives`, { params })
    }

    createObjective(objective: any): Observable<BaseResponse<any>> {
        return this.http.post<BaseResponse<any>>(`${environment.apiUrl}/objectives/create`, objective);
    }

    updateObjective(objective: any): Observable<BaseResponse<any>> {
        if (!objective._id) {
            console.error('Error: No se proporcionó ID para el objetivo');
            throw new Error('ID de objetivo no proporcionado');
        }
        let params = new HttpParams().set('id', objective._id);
        return this.http.post<BaseResponse<any>>(`${environment.apiUrl}/objectives/update`, objective, { params });
    }

    deleteObjective(objectiveId: string): Observable<BaseResponse<any>> {
        let params = new HttpParams().set('objectiveId', objectiveId);
        console.log('params', params.toString());
        return this.http.post<BaseResponse<any>>(`${environment.apiUrl}/objectives/delete`, {}, {params});
    }
}